import { render, staticRenderFns } from "./ETPSubscriptionList.vue?vue&type=template&id=85f87654&scoped=true&"
import script from "./ETPSubscriptionList.vue?vue&type=script&lang=ts&"
export * from "./ETPSubscriptionList.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f87654",
  null
  
)

export default component.exports